<template>
  <a-row>
    <a-row class="content-title" type="flex">
      <h2>Газета</h2>
      <a-row
        class="flex-no__wrap ml-auto wanted-search-input-wrapper"
        type="flex"
      >
        <searchInput
          v-model="inputs.search.text"
          :placeholder="inputs.search.placeholder[$i18n.locale]"
          :searching="inputs.search.spinner"
          @handler="fetchList"
        />
        <a-button
          style="margin-left: auto"
          type="primary"
          @click="$router.push({ name: 'newspaper-create' })"
        >
          <a-icon type="plus" />Добавить
        </a-button>
      </a-row>
    </a-row>
    <a-table
      :columns="columns"
      :data-source="tableProps.results"
      :loading="loading"
      :pagination="false"
      :row-key="(rec) => rec.id"
    >
      <template slot="newspaper_title" slot-scope="item">
        <router-link
          :to="{ name: 'newspaper-slug', params: { slug: item.slug } }"
          class="td-post-item"
          tag="span"
        >
          {{ item.title }}
        </router-link>
      </template>

      <template slot="newspaper_date" slot-scope="item">
        {{ moment(item.date).format("DD-MMM YYYY HH:mm") }}
      </template>

      <template slot="news_lang_list" slot-scope="item">
        <a-tag>
          <img
            width="14"
            class="flag-svg__tab"
            :src="contentLanguages[item.lang].flagSrc"
            :alt="item.lang"
          />
          {{ contentLanguages[item.lang].abr }}
        </a-tag>
      </template>

      <template slot="operation" slot-scope="item">
        <a-icon
          class="action-btns"
          type="edit"
          @click="
            $router.push({
              name: 'newspaper-slug',
              params: { slug: item.slug }
            })
          "
        />
        <a-popconfirm
          title="Вы действительно хотите удалить?"
          cancel-text="Нет"
          ok-text="Да"
          @confirm="deleteA(item.id)"
        >
          <a-icon class="action-btns" style="margin: 0 10px" type="delete" />
        </a-popconfirm>
      </template>
    </a-table>

    <a-pagination
      :current="+$route.query.page || 1"
      :page-size="+$route.query.limit || 10"
      :total="tableProps.count"
      class="mt-1"
      @change="$_setRoutePage"
    />
  </a-row>
</template>

<script>
import { mapState, mapActions } from "vuex"
import { CONTENT_LANGUAGES } from "@/constants"
import newspaperMixin from "@/components/newspaper/newspaper-mixin"
import searchInput from "@/components/newspaper/searchInput/search-input"

export default {
  components: {
    searchInput
  },
  mixins: [newspaperMixin],
  data() {
    return {
      tableProps: {
        results: [],
        count: 1
      },
      loading: false,
      inputs: {
        search: {
          text: "",
          spinner: false,
          placeholder: {
            oz: "Sarlavhani kiriting",
            uz: "Сарлавҳани киритинг",
            ru: "Введите название заголовка",
            en: "Enter the title of heading"
          }
        }
      }
    }
  },
  computed: {
    ...mapState({
      // list: (state) => state.newspaper.results || [],
      // count: (state) => state.newspaper.items_count || 0,
      // loading: (state) => state.newspaper.loading,
    }),

    columns() {
      return [
        {
          title: "Заголовок",
          key: "name",
          scopedSlots: { customRender: "newspaper_title" }
        },
        {
          title: "Дата",
          key: "date",
          scopedSlots: { customRender: "newspaper_date" }
        },
        {
          title: "Доступные языки",
          key: "lang_flags",
          width: "20%",
          scopedSlots: { customRender: "news_lang_list" }
        },
        {
          title: "Действие",
          key: "operation",
          width: "20%",
          scopedSlots: { customRender: "operation" }
        }
      ]
    },

    contentLanguages: () => CONTENT_LANGUAGES
  },
  watch: {
    $route: {
      handler: "fetchList",
      immediate: true
    }
  },
  methods: {
    ...mapActions("newspaper", ["fetch", "deleteA"]),
    async fetchList() {
      this.loading = true

      let page = +this.$route.query.page || 1,
        limit = +this.$route.query.limit || 10

      try {
        // get missing or wanted
        const r = await this.$store.dispatch("wanted/fetch", {
          title: this.inputs.search.text,
          limit,
          page,
          desc: true
        })

        if (r) {
          this.$set(this, "tableProps", {
            results: r.results || [],
            count: +r.items_count
          })
        }
      } catch (e) {
        this.loading = false
      }
      this.loading = false

      // this.fetch({ ...this.defaultPaginationProps(this.$route), desc: true });
    }
    // async onSearch() {
    //   if (
    //     this.inputs.search.text.length == 1 ||
    //     !(
    //       this.wantedType[this.$route.name] &&
    //       this.wantedType[this.$route.name].code
    //     )
    //   ) {
    //     return;
    //   }
    //
    //   this.page = 1;
    //
    //   this.loading = true;
    //
    //   try {
    //     const r = await this.$store.dispatch("wanted/fetch", {
    //       title: this.inputs.search.text,
    //       limit: this.perPage,
    //       page: this.page,
    //       desc: true,
    //     });
    //     console.log(r.results);
    //     if (r) {
    //       // console.log(r);
    //       this.$set(this, "tableProps", {
    //         results: r.results || [],
    //         count: r.count,
    //       });
    //     }
    //   } catch (err) {
    //     console.log(err);
    //     this.loading = false;
    //   }
    //
    //   this.loading = false;
    // },
  }
}
</script>
